import Card from "./Card";
import img1 from '../../src/images/1.jpeg'
import img2 from '../../src/images/2.jpeg'
import img3 from '../../src/images/3.png'
import img4 from '../../src/images/4.jpeg'
import img5 from '../../src/images/5.jpeg'

import {FaAngleRight} from 'react-icons/fa'


export default function Services() {
    return (
        <div>
            <div className="my-5">
                <h1 className="text-center header">Our Services</h1>
            </div>

            <div className="containter-fluid mb-5">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row gy-4">
                            <Card name="Tax Returns and Planning" img={img1}/>
                            <Card name="Business Consulting" img={img2}/>
                            <Card name="Company trust partnership information" img={img3}/>
                            <Card name="BAS, payroll, bookkepping services" img={img4}/>
                            <Card name="Business set up and advice" img={img5}/>
                        </div>
                    </div>
                </div>
            </div>

            {/* How are we different */}

            <div className="my-5">
                <h1 className="text-center header">How are we Different</h1>
            </div>

            <div className="containter-fluid mb-5">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row gy-4">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item"><FaAngleRight/>Get Refund for prior years</li>
                                <li class="list-group-item"><FaAngleRight/>Same day tax Refund, 100% Online Services</li>
                                <li class="list-group-item"><FaAngleRight/>Maximum Tax Refund</li>
                                <li class="list-group-item"><FaAngleRight/>Australia wide clients</li>
                                <li class="list-group-item"><FaAngleRight/>Highly qualified accounting team</li>
                                <li class="list-group-item"><FaAngleRight/>We communicate with phone, email & SMS</li>
                                <li class="list-group-item"><FaAngleRight/>Withdraw tax refund from your Bank Account</li>
                                <li class="list-group-item"><FaAngleRight/>Fill details online, Tax Agent Review and Refund in one hour</li>
                                <li class="list-group-item"><FaAngleRight/>Find your lost PAYG summaries for prior years</li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>


            {/* Advantages */}

            <div className="my-5">
                <h1 className="text-center header">Advantages of a Tax Agent</h1>
            </div>

            <div className="containter-fluid mb-5">
                <div className="row">
                    <div className="col-10 mx-auto">
                        <div className="row gy-4">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item"><FaAngleRight/>Helps boost your tax refund</li>
                                <li class="list-group-item"><FaAngleRight/>Save time worrying about taxes</li>
                                <li class="list-group-item"><FaAngleRight/>Expert help when the ATO sends a letter or comes knocking</li>
                                <li class="list-group-item"><FaAngleRight/>Confience your taxes get done right</li>
                                <li class="list-group-item"><FaAngleRight/>Low fee and Tax-deductible</li>
                                <li class="list-group-item"><FaAngleRight/>Assistance that takes minutes of your time</li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
